import React from 'react';
import PropTypes from 'prop-types';
import MuiRaisedButton from 'material-ui/RaisedButton';
import Icon, { NAMES } from '@ifit/react-icons';
import { Navigation } from '../../navigation/react-redux-nav';
import SummaryIcon from './summary-icon';

import styles from '../../shared-styles';

const TabletPersonalizeSummary = props => (
  <div className="personalize-summary-row">
    <div className="personalize-summary-column">
      { props.personalizePageData.map(personalizePage =>
        <SummaryIcon
          key={ personalizePage.pageTitle }
          pageTitle={ personalizePage.pageTitle }
          pageName={ personalizePage.pageName }
          pageIcon={ personalizePage.pageIcon }
          isCompleted={ props.completedStatus[personalizePage.pageTitle] }
          mediaType="tablet"
        />)
      }
    </div>
    <div className="personalize-summary-column">
      <div className="personalize-avatar-container">
        <div className="personalize-avatar">
          <span className="personalize-avatar-initials">JT</span>
        </div>
      </div>
      <h1>If everything is checked off let's start building your plan.</h1>
      <h2>You can tap on any of the icons to return and edit your answers.</h2>
      <Navigation.Forward>
        <MuiRaisedButton
          className="navigation-button"
          label="Build my plan"
          primary={ true }
          style={{ ...styles.buttonStyle, width: '300px' }}
          buttonStyle={ styles.buttonBorderStyle }
          labelStyle={ styles.buttonLabelStyle }
        >
          <Icon
            className="right-arrow"
            name={ NAMES.ARROW_RIGHT_LONG }
            color={ 'white' }
            size={ 24 }
            unitSize="px"
          />
        </MuiRaisedButton>
      </Navigation.Forward>
    </div>
  </div>
);

TabletPersonalizeSummary.propTypes = {
  completedStatus: PropTypes.object.isRequired,
  personalizePageData: PropTypes.array.isRequired,
};

export default TabletPersonalizeSummary;
